const cleanPath = path => {
	let finalPath = path
	if (path.indexOf('/') >= 0) {
		const pathArr = path.split('/')
		if (pathArr[1] && pathArr[1].length === 2) {
			pathArr.splice(0, 2)
		} else {
			pathArr.splice(0, 1)
		}

		finalPath = pathArr.join('/')
	}

	return finalPath
}

export default cleanPath
